// project import
import admin from './admin';
import crm from './crm';
import account from './account';
import catalog from './catalog'; // medicines and non medicines
import users from './users'
import inventory from './inventory';
import labs from './labs';
import pathology from './pathology';
import radiology from './radiology';
import invoice from './invoice';
import appointments from './appointments';
import ipd from './ipd'; // IPD Management Module
import doctor from './doctor';
import vaccination from './vaccination';
import insurance from './insurance';

// ==============================|| MENU ITEMS ||============================== //

// Add admin to productionItems when there are sub-items in it
const productionItems = [ users, catalog, account, appointments, inventory, invoice, labs, pathology, vaccination, radiology, doctor, ipd, insurance, crm, admin];

const menuItems = {
  items: productionItems
};

export default menuItems;
